import { render, staticRenderFns } from "./technical-specification-type.vue?vue&type=template&id=5d596cc2"
import script from "./technical-specification-type.vue?vue&type=script&lang=js"
export * from "./technical-specification-type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports